import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './App.css';
import Dashboard from './components/Dashboard';
import Transactions from './components/Transactions';
import Subscriptions from './components/Subscriptions';
import Packages from './components/Packages';
import Webhooks from './components/Webhooks';
import { FiRefreshCw } from 'react-icons/fi';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3000';

function App() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE}/api/admin/stats`);
      if (response.data.success) {
        setStats(response.data.data);
      }
    } catch (error) {
      console.error('Error loading stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const refreshAll = () => {
    loadStats();
    window.location.reload();
  };

  return (
    <div className="App">
      <header className="header">
        <div className="header-content">
          <h1>📊 Admin Dashboard</h1>
          <p>NestLink Payment & Subscription System</p>
        </div>
      </header>

      <div className="container">
        <nav className="tabs">
          <button 
            className={`tab ${activeTab === 'dashboard' ? 'active' : ''}`}
            onClick={() => setActiveTab('dashboard')}
          >
            Dashboard
          </button>
          <button 
            className={`tab ${activeTab === 'transactions' ? 'active' : ''}`}
            onClick={() => setActiveTab('transactions')}
          >
            Transactions
          </button>
          <button 
            className={`tab ${activeTab === 'subscriptions' ? 'active' : ''}`}
            onClick={() => setActiveTab('subscriptions')}
          >
            Subscriptions
          </button>
          <button 
            className={`tab ${activeTab === 'packages' ? 'active' : ''}`}
            onClick={() => setActiveTab('packages')}
          >
            Packages
          </button>
          <button 
            className={`tab ${activeTab === 'webhooks' ? 'active' : ''}`}
            onClick={() => setActiveTab('webhooks')}
          >
            Webhooks
          </button>
        </nav>

        <div className="content">
          {activeTab === 'dashboard' && <Dashboard stats={stats} loading={loading} />}
          {activeTab === 'transactions' && <Transactions apiBase={API_BASE} />}
          {activeTab === 'subscriptions' && <Subscriptions apiBase={API_BASE} />}
          {activeTab === 'packages' && <Packages apiBase={API_BASE} />}
          {activeTab === 'webhooks' && <Webhooks apiBase={API_BASE} />}
        </div>
      </div>

      <button className="refresh-btn" onClick={refreshAll} title="Refresh Data">
        <FiRefreshCw />
      </button>
    </div>
  );
}

export default App;
